export const TipoConsulta = {
    GENERAL: "GENERAL",
    POR_DOCUMENTO: "POR_DOCUMENTO",
};